import React from 'react'
import { Grid } from '@mui/material'
import MySummaryEntitlementSplit from '../../shared/UI/MySummaryEntitlementSplit/MySummaryEntitlementSplit'
import WfhEntitlementSplit from '../../shared/UI/WfhEntitlementSplit/WfhEntitlementSplit'
import NoDataFound from '../../shared/UI/NoDataFound'
import LoadingIndicator from '../../shared/UI/LoadingIndicator'
import { EntitlementSplit } from '../../types/entitlement-split'
import Card from '../../shared/layout/Card'

interface SummaryCardProps {
  entitlementSplit: EntitlementSplit | undefined
  wfhEntitlementSplit: EntitlementSplit | undefined
  isWfhOccurrence: boolean
  isLoading: boolean
}

function SummaryCard({
  entitlementSplit,
  wfhEntitlementSplit,
  isWfhOccurrence,
  isLoading,
  }: SummaryCardProps) {
    return (
      <Grid item xs={12}>
        <Card title="Summary">
          {entitlementSplit && wfhEntitlementSplit ? (
            <Grid container spacing={4}>
              <Grid item xs={12}>
                {isWfhOccurrence ? (
                  <WfhEntitlementSplit
                    marginTop={0}
                    marginBottom={0}
                    titleMarginBottom={1}
                    summaryItems={wfhEntitlementSplit}
                  />
                  ) : (
                    <MySummaryEntitlementSplit
                      marginTop={0}
                      marginBottom={0}
                      titleMarginBottom={1}
                      summaryItems={entitlementSplit}
                    />
                  )}
              </Grid>
            </Grid>
          ) : (
            <>
              <NoDataFound show={!isLoading} />
              <LoadingIndicator show={isLoading} />
            </>
          )}
        </Card>
      </Grid>
    )
}

export default SummaryCard